import { render, staticRenderFns } from "./BusinessDialogue.vue?vue&type=template&id=150c056a&scoped=true&"
import script from "./BusinessDialogue.vue?vue&type=script&lang=js&"
export * from "./BusinessDialogue.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDialogue.vue?vue&type=style&index=0&id=150c056a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c056a",
  null
  
)

export default component.exports